import type { DateFormat } from '../types'

/**
 * Format a date string according to user's preferred format
 */
export const formatDate = (dateStr: string, format: DateFormat): string => {
  const date = new Date(dateStr)
  if (isNaN(date.getTime())) return dateStr

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()

  switch (format) {
    case 'DD/MM/YYYY':
      return `${day}/${month}/${year}`
    case 'MM/DD/YYYY':
      return `${month}/${day}/${year}`
    case 'YYYY-MM-DD':
      return `${year}-${month}-${day}`
    default:
      return `${day}/${month}/${year}`
  }
}

/**
 * Format a date string as relative time (e.g., "today", "2d ago", "1w ago")
 */
export const formatRelativeDate = (dateStr: string): string => {
  const date = new Date(dateStr)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))

  if (diffDays === 0) return 'today'
  if (diffDays === 1) return 'yesterday'
  if (diffDays < 7) return `${diffDays}d ago`
  if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`
  if (diffDays < 365) return `${Math.floor(diffDays / 30)}mo ago`
  return `${Math.floor(diffDays / 365)}y ago`
}

/**
 * Format a date with both relative and absolute format
 * Returns: "2d ago (23/12/2024)"
 */
export const formatDateWithRelative = (dateStr: string, format: DateFormat): string => {
  const relative = formatRelativeDate(dateStr)
  const absolute = formatDate(dateStr, format)
  return `${relative} (${absolute})`
}

export const DATE_FORMAT_LABELS: Record<DateFormat, string> = {
  'DD/MM/YYYY': 'DD/MM/YYYY (European)',
  'MM/DD/YYYY': 'MM/DD/YYYY (American)',
  'YYYY-MM-DD': 'YYYY-MM-DD (ISO)',
}

